
import { Ajax, AjaxError, ISupportSpinner } from '../shared/Ajax';

import {Option} from '../models/Option'

export class IndustryController extends Ajax {
    constructor() {
        super(window.__emdgBaseUrl, '/api/industry');
    }
    
        getIndustryMatches(owner:ISupportSpinner, searchTxt:string, success:{(res:Option<string>[]):any}, error?:AjaxError) {
    super._call('get', 'industrySearch', owner, {searchTxt:searchTxt}, null, success, error)
}

        getCommodityMatches(owner:ISupportSpinner, searchTxt:string, success:{(res:Option<string>[]):any}, error?:AjaxError) {
    super._call('get', 'CommoditySearch', owner, {searchTxt:searchTxt}, null, success, error)
}
}
